module.exports = __webpack_public_path__ + "static/tvr-performance-a53746f6e20536123781faeeb6cc74cf.png";